require('../../modules/es.regexp.flags');
var flags = require('../../internals/regexp-flags');

module.exports = function (it) {
  return flags.call(it);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/regexp/flags.js
// module id = 653
// module chunks = 0